export const linksData = [
  // Digital Tools [5]
  {
    groupId: 5,
    links: [
      {
        parentId: 5,
        linkId: 1,
        linkLabel: 'Digital Tools',
        linkUrl: '/digital-tools',
      },
      {
        parentId: 5,
        linkId: 2,
        linkLabel: 'Logistics Explorer',
        linkUrl: '/digital-tools/logistics-explorer/',
      },
      {
        parentId: 5,
        linkId: 3,
        linkLabel: 'Tracking System',
        linkUrl: '/digital-tools/tracking-system',
      },
      {
        parentId: 5,
        linkId: 4,
        linkLabel: 'Ship Schedules',
        linkUrl: '/digital-tools/ship-schedules',
      },
      // {
      //   parentId: 5,
      //   linkId: 5,
      //   linkLabel: 'Cargoes Flow',
      //   linkUrl: '/digital-tools/cargoes-flow',
      // },
    ],
  },
  // Company [1]
  {
    groupId: 1,
    links: [
      {
        parentId: 1,
        linkId: 1,
        linkLabel: 'Company',
        linkUrl: '/company/vision-strategy',
      },
      {
        parentId: 1,
        linkId: 2,
        linkLabel: 'Vision & Strategy',
        linkUrl: '/company/vision-strategy',
      },
      {
        parentId: 1,
        linkId: 3,
        linkLabel: 'Contact Us',
        linkUrl: '/company/contact-us',
      },
      {
        parentId: 4,
        linkId: 4,
        linkLabel: 'Membership Regulations',
        linkUrl: '/company/membership-regulations',
      },
      {
        parentId: 4,
        linkId: 5,
        linkLabel: 'Code of Ethics',
        linkUrl: '/company/code-of-ethics',
      },
      {
        parentId: 4,
        linkId: 6,
        linkLabel: 'Privacy Policy',
        linkUrl: '/resources/privacy-policy',
      },
      {
        parentId: 4,
        linkId: 7,
        linkLabel: 'Terms and Conditions',
        linkUrl: '/resources/terms-and-conditions',
      },
      {
        parentId: 1,
        linkId: 8,
        linkLabel: 'FAQs',
        linkUrl: '/company/faqs',
      },
      // {
      //   parentId: 1,
      //   linkId: 9,
      //   linkLabel: 'Blacklist',
      //   linkUrl: '/company/blacklist',
      // },
    ],
  },
  // Benefits [2]
  {
    groupId: 2,
    links: [
      {
        parentId: 2,
        linkId: 1,
        linkLabel: 'Benefits',
        linkUrl: '/benefits',
      },
      {
        parentId: 2,
        linkId: 2,
        linkLabel: 'Shipping Leads',
        linkUrl: '/benefits/shipping-leads',
      },
      {
        parentId: 2,
        linkId: 3,
        linkLabel: 'Networking',
        linkUrl: '/benefits/networking',
      },
      {
        parentId: 2,
        linkId: 4,
        linkLabel: 'Support',
        linkUrl: '/benefits/support',
      },
      {
        parentId: 2,
        linkId: 5,
        linkLabel: 'Global Freight Forwarders List & Directory',
        linkUrl: '/benefits/member-directory',
      },
      {
        parentId: 2,
        linkId: 7,
        linkLabel: 'Brand Reliability',
        linkUrl: '/benefits/brand-reliability',
      },
      {
        parentId: 3,
        linkId: 8,
        linkLabel: 'Trade Finance',
        linkUrl: '/services/trade-finance',
      },
    ],
  },
  // Resources [4]
  {
    groupId: 4,
    links: [
      {
        parentId: 4,
        linkId: 1,
        linkLabel: 'Resources',
        linkUrl: '/resources',
      },
      {
        parentId: 4,
        linkId: 2,
        linkLabel: 'Freight Dictionary',
        linkUrl: '/freight-dictionary',
      },
      {
        parentId: 4,
        linkId: 3,
        linkLabel: 'How to Become a Freight Forwarder',
        linkUrl: '/freight-forwarder',
      },
      {
        parentId: 4,
        linkId: 4,
        linkLabel: 'Bill of Lading',
        linkUrl: '/resources/bill-of-lading',
      },
      {
        parentId: 4,
        linkId: 5,
        linkLabel: 'Freight Templates',
        linkUrl: '/resources/freight-templates',
      },
      {
        parentId: 4,
        linkId: 6,
        linkLabel: 'Demurrage and Detention',
        linkUrl: '/resources/demurrage-and-detention',
      },
      {
        parentId: 1,
        linkId: 7,
        linkLabel: 'Blog',
        linkUrl: '/blog',
      },
    ],
  },
];
